import React from 'react';
import styled from 'styled-components/macro';
import translate from './TranslateHOC';
import { passwordStrengthFeedback } from '../form_helpers';

function StrengthMeter({ passStrength, strings }) {
  return (
    <StrengthMeterContainer>
      <StrengthMeterInner>
        {[...Array(4)].map((_, index) => (
          <Segment
            key={index}
            isActive={index < passStrength}
            currentStrengthLevel={passStrength}
          />
        ))}
      </StrengthMeterInner>
      <Feedback>{passwordStrengthFeedback(passStrength, strings)}</Feedback>
    </StrengthMeterContainer>
  );
}

const lightTheme = {
  0: '#C3C3C3',
  1: '#F04A4A',
  2: '#FABB54',
  3: '#00AA55',
  4: '#3CD771',
};

const darkTheme = {
  0: '#4C4C4B',
  1: '#F04A4A',
  2: '#FABB54',
  3: '#00AA55',
  4: '#3CD771',
};

const getThemeColours = (theme) =>
  theme.name === 'light' ? lightTheme : darkTheme;

const StrengthMeterContainer = styled.div``;

const StrengthMeterInner = styled.div`
  display: flex;
  gap: 4px;
  height: 8px;
  margin-bottom: 10px;
  margin: 0 20px;
`;

const Segment = styled.div`
  flex-grow: 1;
  height: 100%;
  background-color: ${(props) => {
    const themeColours = getThemeColours(props.theme);
    if (props.currentStrengthLevel > 0 && props.isActive) {
      return themeColours[props.currentStrengthLevel];
    }
    return themeColours[0];
  }};
  border-radius: 2px;
  transition: background-color 0.3s;
`;

const Feedback = styled.div`
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
  margin: 10px 20px;
  font-size: 18px;
`;

export default translate(StrengthMeter);
